import React from 'react'
import Container from '../components/Container'
import Title from '../components/Title'

import { Swiper, SwiperSlide } from 'swiper/react'
import Box from '../components/Box'
import { ReactComponent as Stars } from '../assets/svg/stars.svg'
function Reviews() {
    return (
        <>
            <Container>
                <div className='flex flex-col gap-5'>
                    <Title className='text-center !text-black'>
                        What Our Clients Say
                    </Title>
                    <div className='text-center text-base md:text-xl'>
                        Trusted by countless customers, we take pride in delivering exceptional locksmith services. Here's what some of them have to say about their experience with us.
                    </div>

                </div>
            </Container>
            <Swiper
                spaceBetween={20}
                centerInsufficientSlides={true}
                breakpoints={{
                    0: {
                        slidesPerView: 1.1,
                    },
                    600: {
                        slidesPerView: 2.1,
                    },
                    900: {
                        slidesPerView: 2.7,
                    },
                    1100: {
                        slidesPerView: 3.2,
                    },
                    1350: {
                        slidesPerView: 3.5,
                    },
                    1600: {
                        slidesPerView: 4.2,
                    }
                }}
                className='!pt-10 !pb-5 !px-4 max-w-[1700px] mx-auto'
            >
                <SwiperSlide>
                    <Box>
                        <div className='mb-3 flex gap-3 items-center'>
                            <img src={require('../assets/images/profilePlaceholder.png')} alt="" />
                            <span className='font-bold'>John Müller</span>
                            <Stars className='ms-auto' />
                        </div>
                        <span className='text-[#666666] leading-[27px]'>
                            "From the first call to the final repair, everything was handled with professionalism and care. Outstanding experience!"
                        </span>
                    </Box>

                </SwiperSlide>
                <SwiperSlide>
                    <Box>
                        <div className='mb-3 flex gap-3 items-center'>
                            <img src={require('../assets/images/profilePlaceholder.png')} alt="" />
                            <span className='font-bold'>John Müller</span>
                            <Stars className='ms-auto' />
                        </div>
                        <span className='text-[#666666] leading-[27px]'>
                            "From the first call to the final repair, everything was handled with professionalism and care. Outstanding experience!"
                        </span>
                    </Box>

                </SwiperSlide>
                <SwiperSlide>
                    <Box>
                        <div className='mb-3 flex gap-3 items-center'>
                            <img src={require('../assets/images/profilePlaceholder.png')} alt="" />
                            <span className='font-bold'>John Müller</span>
                            <Stars className='ms-auto' />
                        </div>
                        <span className='text-[#666666] leading-[27px]'>
                            "From the first call to the final repair, everything was handled with professionalism and care. Outstanding experience!"
                        </span>
                    </Box>

                </SwiperSlide>
                <SwiperSlide>
                    <Box>
                        <div className='mb-3 flex gap-3 items-center'>
                            <img src={require('../assets/images/profilePlaceholder.png')} alt="" />
                            <span className='font-bold'>John Müller</span>
                            <Stars className='ms-auto' />
                        </div>
                        <span className='text-[#666666] leading-[27px]'>
                            "From the first call to the final repair, everything was handled with professionalism and care. Outstanding experience!"
                        </span>
                    </Box>

                </SwiperSlide>
            </Swiper>
        </>
    )
}

export default Reviews